<template>
  <div class="fd_body" v-if="body_show">
    <!-- 公用头部 -->
    <public-header :colors="'#fff'" :headimg="headImg"></public-header>
    <!-- 图片 -->
    <div class="men_detail">
      <img :key="item" v-for="item in imgData" :src="item" alt="" />
    </div>
    <!-- 底部 -->
    <div class="md_hs clearfix">
      <router-link to="/fission" class="md_hsl">排行榜</router-link>
      <router-link :to="'/make_money?cid='+cid" class="md_href">我要赚钱</router-link>
    </div>
  </div>
</template>
<script>
import {
  getActivity
} from "@/api/course"
import {
  statistics
} from "@/api/public"
import {
  shareCon
} from "@/utils/wxconfig";
export default {
  data() {
      return {
        body_show: false,
        cid: ''
      }
    },
    methods: {
      pullData() {
        this.cid = this.$route.query.cid;
        getActivity({
            cid: this.cid
          })
          .then((data) => {
            shareCon("course", this);
            if (data.jump) {
              this.body_show = true;
            }else {
              this.$router.push({
                path: '/make_money',
                query: {
                  cid: this.cid
                }
              })
            }
          })


      }
    },
    created() {
      shareCon("course", this);
      this.cid = this.$route.query.cid;
      this.body_show = true;
    }
}
</script>
<style lang="scss" scoped>
@import "@s/remChange.scss";
.fd_body {
  background: url(../../../assets/fd_body.png) repeat-y top center;
  background-size: contain;
  width: 100%;
  height: 100%;
  padding-bottom: changeRem(3)+px;
}

.men_detail {
  img {
    max-width: 100%;
    display: block;
  }
}

.men_detaips {
  width: 100%;
  height: changeRem(11.3)+px;
  background: url(../../../assets/md_bg.png) no-repeat top center;
  background-size: cover;
  margin: 0 auto;
  text-align: center;
  padding-top: changeRem(1.4)+px;
  h2 {
    font-size: changeRem(0.68)+px;
    color: #333;
    font-weight: bold;
  }
  h1 {
    font-size: changeRem(1)+px;
    color: #EB5032;
    margin-top: changeRem(1)+px;
  }
  h3 {
    font-size: changeRem(0.6)+px;
    color: #333;
    line-height: changeRem(0.92)+px;
    margin-top: changeRem(0.6)+px;
    font-weight: normal;
    span {
      color: #EB5032;
    }
  }
  .ps_dl {
    font-size: changeRem(0.6)+px;
    margin: 0 auto;
    margin-top: changeRem(1.08)+px;
    width: changeRem(8.8)+px;
    // height: changeRem(2.52)+px;
    background: rgba(245, 127, 23, 1);
    padding: changeRem(0.4)+px 0;
    line-height: changeRem(0.8)+px;
    color: #fff;
    text-align: center;
  }
}

.md_hs {
  height: changeRem(1.96)+px;
  padding: 0;
  background: #fff;
  width: 100%;
  max-width: 750px;
  position: fixed;
  left: 50%;
  margin-left: -375px;
  bottom: 0;
  text-align: center;
  .md_hsl {
    float: left;
    width: 214px;
    height: changeRem(1.96)+px;
    line-height: changeRem(1.96)+px;
    background: #fff;
    font-size: 34px;
    color: #EB5032;
  }
  .md_href {
    width: 536px;
    float: right;
    height: changeRem(1.96)+px;
    line-height: changeRem(1.96)+px;
    background: rgba(235, 80, 50, 1);
    display: block;
    color: #fff;
    font-size: 35px;
    border-radius: 0;
  }
}

.pop_img {
  width: 100%;
  height: 100%;
  z-index: 100001;
  position: fixed;
  top: 0;
  left: 0;
  background: url(../../../assets/popse.png) no-repeat top center;
  background-size: cover;
}
</style>
